import React,{ useEffect, useState } from 'react';
import styles from '../styles.scss';
import { history } from 'umi';



export default (props) => {
  const {course, isLike,isCollect, onClick} = props;

  return(
    <div className={styles.bottomBar}>

      <div className={styles.bottomItem} onClick={() =>{
        onClick && onClick(0);
      }}>
        <img src={require('@/assets/ic_comment.png')}/>
        <label>评论</label>
      </div>
      <div className={styles.bottomItem} onClick={() =>{
        onClick && onClick(1);
      }}>
        <img src={isLike == '0' ? require('@/assets/ic_like.png') : require('@/assets/ic_liked.png')}/>
        <label style={{color: isLike == '0' ? '#555' : '#57B99D'}}>{isLike == '0' ? '点赞' : '已赞'}</label>
      </div>
      {/*<div className={styles.bottomItem} onClick={() =>{*/}
        {/*onClick && onClick(2);*/}
      {/*}}>*/}
        {/*<img src={require('@/assets/ic_share.png')}/>*/}
        {/*<label>分享</label>*/}
      {/*</div>*/}
      <div className={styles.bottomItem} onClick={() =>{
        onClick && onClick(3);
      }}>
        <img src={isCollect == '0' ? require('@/assets/ic_collect.png') : require('@/assets/ic_collected.png')}/>
        <label style={{color: isCollect == '0' ? '#555' : '#57B99D'}}>{isCollect == '0' ? '收藏' : '已收藏'}</label>
      </div>
    </div>
  )
}
